// src/Components/Common/ActionButton.jsx
import React from "react";
import { Button } from "reactstrap";
import PropTypes from "prop-types";

const ActionButton = ({
  onClick,
  loading = false,
  disabled = false,
  buttonType = "plot", // "plot", "table" or "download"
  loadingText = null,
  customText = null,
  icon = null,
  style = {},
  size = "md",
  className = "",
}) => {
  // Default configurations for different button types
  const getButtonConfig = () => {
    if (buttonType === "table") {
      return {
        defaultText: "Generate Table",
        defaultIcon: "ri-table-line",
        defaultLoadingText: "Generating...",
        backgroundColor: "#1A6D51", // EIRNA green for tables
      };
    } else if (buttonType == "download") {
      return {
        defaultText: "Generate Table",
        defaultIcon: "ri-table-line",
        defaultLoadingText: "Generating...",
        backgroundColor: "#2F9E37", // Lighter green
      };
    } else {
      // Default to plot button
      return {
        defaultText: "View Plot",
        defaultIcon: "ri-play-line",
        defaultLoadingText: "Generating...",
        backgroundColor: "#1A6D51", // Darker green for plots
      };
    }
  };

  const config = getButtonConfig();

  // Determine button text
  const getButtonText = () => {
    if (loading && loadingText) return loadingText;
    if (loading) return config.defaultLoadingText;
    if (customText) return customText;
    return config.defaultText;
  };

  // Determine icon
  const getButtonIcon = () => {
    if (icon) return icon;
    return config.defaultIcon;
  };

  // Default button styles
  const defaultStyle = {
    backgroundColor: config.backgroundColor,
    color: "white",
    border: "none",
    padding:
      size === "sm" ? "6px 12px" : size === "lg" ? "12px 24px" : "10px 20px",
    fontSize: size === "sm" ? "12px" : size === "lg" ? "16px" : "14px",
    fontWeight: "600",
    borderRadius: "14px",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    transition: "all 0.2s ease",
    cursor: disabled || loading ? "not-allowed" : "pointer",
    opacity: disabled || loading ? 0.7 : 1,
    ...style,
  };

  return (
    <Button
      onClick={onClick}
      disabled={disabled || loading}
      style={defaultStyle}
      className={className}
      size={size}
    >
      <i className={getButtonIcon()}></i>
      {getButtonText()}
    </Button>
  );
};

ActionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  buttonType: PropTypes.oneOf(["plot", "table", "download"]),
  loadingText: PropTypes.string,
  customText: PropTypes.string,
  icon: PropTypes.string,
  style: PropTypes.object,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  className: PropTypes.string,
};

export default ActionButton;
